export const protocolFieldTypes = Object.freeze({
  TEXT: 'TEXT',
  LIST: 'LIST',
  NUMERIC: 'NUMERIC',
  DATE: 'DATE',
  CURRENCY: 'CURRENCY',
  HOUR: 'HOUR',
  LINK: 'LINK'
});
